var render, staticRenderFns
import script from "./AtomTextHeading.vue?vue&type=script&lang=js&"
export * from "./AtomTextHeading.vue?vue&type=script&lang=js&"
import style0 from "./AtomTextHeading.vue?vue&type=style&index=0&id=e2a0dbba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a0dbba",
  null
  
)

export default component.exports